import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import auth from 'store/app/auth/action';
import authConfig from 'store/app/authConfig/action';
import companies from 'store/app/entities/companies/action';
import login from 'store/app/ui/login/action';
import form from 'store/app/ui/login/form/action';
import keepSessionOpen from 'store/selectors/keepSessionOpen';
import returnUrl from 'store/selectors/returnUrl';

const mapStateToProps = state => ({
  locale: state.i18n.locale,
  login: state.login,
  form: state.login.form,
  loginType: state.login.authRequestUser ? state.login.authRequestUser.loginType : 'sms',
  isAcceptTerms: !!(state.login.authRequestUser && state.login.authRequestUser.isAcceptTerms),
  returnUrl: returnUrl(state),
  keepSessionOpen: keepSessionOpen(state),
});

const mapDispatchToProps = dispatch => ({
  actions: {
    auth: bindActionCreators(auth, dispatch),
    authConfig: bindActionCreators(authConfig, dispatch),
    login: {
      ...bindActionCreators(login, dispatch),
      form: bindActionCreators(form, dispatch),
    },
    companies: bindActionCreators(companies, dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
